import { Component, ViewChild, OnInit } from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';
import { environment } from '../../../environments/environment.development';

interface Install {
  active: number;
  direccion: string;
  numero: string;
  localidad: string;
  cp: string;
  provincia: string;
  api_key: string;
}

interface LatLong {
  latitude: number;
  length: number;
}

@Component({
  selector: 'app-map-google',
  standalone: true,
  imports: [],
  templateUrl: './map-google.component.html',
  styleUrls: ['./map-google.component.scss'],
})
export class MapGoogleComponent implements OnInit {
  center: google.maps.LatLngLiteral = { lat: 39.571625, lng: 2.650544 };
  mapOptions: google.maps.MapOptions = {
    gestureHandling: 'greedy',
    styles: this.getMapStyles(),
  };

  loader?: Loader; // to load the Google Maps API

  ngOnInit(): void {
    this.loader = new Loader({
      apiKey: environment.data_gmaps.api_key,
      version: environment.data_gmaps.version,
    });

    // Load the Google Maps API
    this.loader
      .load()
      .then(() => {
        // When the API is loaded, we initialize the map
        this.initMap();
      })
      .catch((error) => {
        console.error('Error cargando la API de Google Maps:', error);
      });
  }

  initMap() {
    const map = new google.maps.Map(
      document.getElementById('map') as HTMLElement,
      {
        center: this.center,
        zoom: 10,
        mapTypeId: 'roadmap',
        ...this.mapOptions,
      }
    );

    this.initMarkers(map);
  }

  async initMarkers(map: google.maps.Map) {
    try {
      const response = await fetch(
        'https://apiv2.connect24.io/v1/installs/dcc2274e6c4e1d88edf13aac35cf13c6d92c0334ff77684b7ffe1de741522d1b'
      )
        .then((response) => response.json())
        .then((data: Install[]) => {
          const filteredData = data.filter((data) => data.active == 1);

          const infoWindow = new google.maps.InfoWindow();
          filteredData.map(async (item) => {
            const adressLat = `calle ${item.direccion}, ${item.numero}, ${item.localidad}`;
            const adress = `${item.direccion}, ${item.numero}, ${item.cp}, ${item.localidad}, ${item.provincia}`;
            try {
              const coords = await this.getLatLong(adressLat);

              const markerPosition = {
                lat: coords.latitude,
                lng: coords.length,
              };

              const image = await this.getImages(item.api_key);

              const marker = new google.maps.Marker({
                map: map,
                position: markerPosition,
                icon: image,
                title: adress,
              });

              const content = `<b style="color: black">${adress}</b>`;

              marker.addListener('click', () => {
                infoWindow.close();
                infoWindow.setContent(content);
                infoWindow.open(map, marker);
              });
            } catch (error) {
              console.error('Error obteniendo coordenadas o imagen:', error);
            }
          });
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  async getImages(item: string) {
    const image_red = {
      url: 'https://controller.connect24.io/operator/map/marker_red.png',
    };
    const image_green = {
      url: 'https://controller.connect24.io/operator/map/marker_green.png',
    };
    const image_orange = {
      url: 'https://controller.connect24.io/operator/map/marker_orange.png',
    };

    let image = image_green;
    try {
      const response = await fetch(
        `https://apiv2.connect24.io/v1/install/alarms/count/${item}`
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.warning > 0) {
            image = image_orange;
          }
          if (data.critical > 0) {
            image = image_red;
          }
        });
    } catch (error) {
      console.error('Error fetching image:', error);
    }
    return image;
  }

  getLatLong(direccion: string): Promise<LatLong> {
    const geocoder = new google.maps.Geocoder();
    return new Promise((resolve, reject) => {
      geocoder.geocode({ address: direccion }, (results, status) => {
        if (
          status === google.maps.GeocoderStatus.OK &&
          results &&
          results.length > 0
        ) {
          const latitude = results[0].geometry.location.lat();
          const length = results[0].geometry.location.lng();
          resolve({ latitude, length });
        } else {
          reject('Geocoding no tuvo éxito debido a: ' + status);
        }
      });
    });
  }

  private getMapStyles() {
    return [
      { elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
      { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
      { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] },
      {
        featureType: 'administrative.locality',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#d59563' }],
      },
      {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{ color: '#38414e' }],
      },
      {
        featureType: 'road',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#212a37' }],
      },
      {
        featureType: 'road',
        elementType: 'labels.text.fill',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'transit',
        elementType: 'geometry',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'transit.station',
        elementType: 'labels.text.fill',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{ color: '#17263c' }],
      },
      {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#515c6d' }],
      },
      {
        featureType: 'water',
        elementType: 'labels.text.stroke',
        stylers: [{ color: '#17263c' }],
      },
      {
        featureType: 'poi',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'transit',
        elementType: 'labels.icon',
        stylers: [{ visibility: 'off' }],
      },
      {
        elementType: 'labels.icon',
        stylers: [{ visibility: 'off' }],
      },
    ];
  }
}
